import React from 'react'
import AdviserContactDetails from './AdviserContactDetails'
import { connect } from 'react-redux'
import Spinner from '../../common/Spinners/Spinner'
import { fetchPublishedProfile } from '../AdviserProfile/AdviserProfileContainer/adviserProfileContainerActions'
import PropTypes from 'prop-types';

class AdviserContactDetailsContainer extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    profile: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    fetchPublishedProfile: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.dispatch(this.props.fetchPublishedProfile(this.props.adviserId, [this.props.profile]))
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    const { adviserId, profile, loading, fetchPublishedProfile, dispatch, ...props } = this.props // eslint-disable-line no-unused-vars
    return <AdviserContactDetails adviser={this.props.profile} {...props} />
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.adviserProfileContainer.profile,
    loading: state.adviserProfileContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    fetchPublishedProfile: fetchPublishedProfile
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserContactDetailsContainer)
